import { render, staticRenderFns } from "./screenTransabilidaAlcance.vue?vue&type=template&id=5f0537d8"
import script from "./screenTransabilidaAlcance.vue?vue&type=script&lang=js"
export * from "./screenTransabilidaAlcance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports